import { render, staticRenderFns } from "./ReviewItemFacilityData.vue?vue&type=template&id=1c1b46d5&scoped=true&"
import script from "./ReviewItemFacilityData.vue?vue&type=script&lang=js&"
export * from "./ReviewItemFacilityData.vue?vue&type=script&lang=js&"
import style0 from "./ReviewItemFacilityData.vue?vue&type=style&index=0&id=1c1b46d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1b46d5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
